import { createContext, useContext } from "react";

import type { StagedEdge, StagedSchedule, EdgePatch } from "@/domains/pm/hooks/useStagedSchedule";

export interface ScheduleStagingApi {
  staged: StagedSchedule;
  /** Returns the staged edge's local (negative) id. */
  stageEdgeAdd: (edge: Omit<StagedEdge, "localId">) => number;
  stageEdgeEdit: (edgeId: number, patch: EdgePatch) => void;
  stageEdgeDrop: (edgeId: number) => void;
  /** Send the whole arrangement to the server, after a preview. */
  confirm: () => void;
  discard: () => void;
  /** True while the confirm round trip is in flight. */
  saving: boolean;
}

export const ScheduleStagingContext = createContext<ScheduleStagingApi | null>(null);

/**
 * The Gantt's unsaved arrangement, when one is being kept.
 *
 * Null everywhere else, and callers must handle that by writing immediately —
 * the same explicit shape as `useScheduleChangeApi`. A surface that silently
 * staged a change nobody could see or confirm would lose the edit.
 */
export function useScheduleStaging(): ScheduleStagingApi | null {
  return useContext(ScheduleStagingContext);
}
